import Page from '../../class/Page';
import Accordion from '../../components/accordion';

window.pageCurrent = class extends Page {
    init() {
        super.init();

        this.app.vue.buildSingleComponent(
            document.getElementById('user-cart'),
            require('./vue/Cart.vue')
        );

        this.initAllComponents('.accordion-item', Accordion);
    }
};
